module.exports = __webpack_public_path__ + "static/img/1152_phase_function_Paper_Points.030b774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1152_phase_function_Paper_Points.png
// module id = R5mc
// module chunks = 0